module.exports = __webpack_public_path__ + "img/Yr3FundsUsage.6b1fd629.png";